import { useEffect, useRef, useState } from "react";
import { FaSignOutAlt, FaList } from "react-icons/fa";
import logo from "./resources/images/ChemiNova_logo.png";
import { useAuth } from "../contexts/AuthContext";
import { useLocation, useNavigate } from "react-router-dom";
import SETTINGS from "../globals";
import AppSections from "../utils/AppSections";
import { topMenuItems } from "../utils/MenuDefinition";
import EmbeddingToolInfo from "../utils/EmbeddingToolInfo";
import Button from "./common/button/Button";
import ButtonType from "./common/button/ButtonType";
import ButtonAction from "./common/button/ButtonAction";
import { WebViewDTO } from "../model/WebViewDTO";
import AppIcons from "../utils/AppIcons";
import { FaUser } from "react-icons/fa6";
import AppSubSections from "../utils/AppSubSections";
import { useApiClient } from "../contexts/ApiClientContext";
import APIEndPoints from "../utils/APIEndPoints";

const chemiPortalVersion = "v1.0";

function TopMenu() {
  const [submenuOpen, setSubmenuOpen] = useState(false);
  // reference to the AuthManager
  const authManager = useAuth();
  // reference to the navigator
  const navigate = useNavigate();
  // we need to identify current location for menu highlighting
  const location = useLocation();
  // extract section from location
  const section = location.pathname.split("/")[1];
  const subsection = location.pathname.split("/")[2];
  const apiClient = useApiClient();

  console.log("section = " + section);
  // settings received from the tools
  const [webViewInfo, setWebViewInfo] = useState<WebViewDTO | undefined>(
    undefined,
  );

  const menuRef = useRef<HTMLUListElement | null>(null);

  const toggleSubmenu = () => {
    setSubmenuOpen(!submenuOpen);
  };

  
  const signOut = () => {
    // authManager.signOut(apiClient);

    authManager.signOut(apiClient).finally(() => {
      window.location.href = SETTINGS.API_ROOT + APIEndPoints.OAUTH.LOGOUT;
    });

  };

  useEffect(() => {
    try {
      // load selected information that has been injected by the tool
      const webViewData = localStorage.getItem("web_view_dto");
      let auxWebViewInfo: WebViewDTO | undefined = undefined;
      if (webViewData) {
        auxWebViewInfo = JSON.parse(webViewData);
        setWebViewInfo(auxWebViewInfo);
      }
    } catch (exception) {}
    const handler = (event: MouseEvent | TouchEvent) => {
      if (
        submenuOpen &&
        menuRef.current &&
        !menuRef.current.contains(event.target as Node)
      ) {
        setSubmenuOpen(false);
      }
    };
    document.addEventListener("mousedown", handler);
    document.addEventListener("touchstart", handler);
    return () => {
      document.removeEventListener("mousedown", handler);
      document.removeEventListener("touchstart", handler);
    };
  }, [submenuOpen]);

  const submenuLinkCSS =
    "block w-full whitespace-nowrap bg-transparent px-4 py-2 text-sm font-normal text-neutral-700 hover:bg-zinc-200/60 focus:bg-zinc-200/60 focus:outline-none active:bg-zinc-200/60 active:no-underline";

  if (EmbeddingToolInfo.isChemiAnalysis()) {
    return (
      <nav
        className="flex w-full flex-wrap items-center justify-between py-2 fixed z-50 top-0 bg-white drop-shadow-md"
        data-twe-navbar-ref
      >
        <div className="flex w-full flex-wrap items-center justify-between px-3 shadow-dark-mild">
          <div>
            <img src={logo} className="h-6" alt="" />
          </div>
          <div className="absolute mt-4 ml-32 text-sm">
            {chemiPortalVersion}
          </div>
          <div className="relative ml-20 flex-grow text-center pr-24">
            {webViewInfo?.windowTitle}
          </div>
          <div>
            <Button
              label=""
              type={ButtonType.ICON}
              purpose={ButtonAction.CANCEL}
              onClick={() => {
                const payload = "unity:popup_action=close";
                if (EmbeddingToolInfo.isToolOnWindows()) {
                  // @ts-ignore
                  uwb.ExecuteJsMethod("JSCallback", payload);
                } else {
                  window.location.href = payload;
                }
              }}
            />
          </div>
        </div>
      </nav>
    );
  }

  return (
    <nav
      className="flex w-full flex-wrap items-center justify-between py-2 fixed z-50 top-0 bg-white drop-shadow-md"
      style={{ minWidth: "1200px" }}
      data-twe-navbar-ref
    >
      <div className="flex w-full flex-wrap items-center justify-between px-3 py-4 shadow-dark-mild pr-8">
        <div>
          <a href="/">
            <img src={logo} className="h-8" alt="" />
          </a>
        </div>
        <ul className="relative ml-20 flex-grow text-left">
          {topMenuItems
            // display menu elements according to the user's role
            /*.filter((item) => {
              // Restrict "Add Cultural Heritage Asset" to admin, moderator, specialist
              if (item.label === "Add Cultural Heritage Asset") {
                return (
                  authManager.isAdmin() ||
                  authManager.isModerator?.() ||
                  authManager.isSpecialist?.()
                );
              }

              // check if the user is authenticated
              if (authManager.getToken()) {
                return true;
              }

              // For everything else:
              return authManager.isAdmin()
                ? true
                : item.audience === Audience.ANONYMOUS;
            })*/
            .map((item, index) => {
              // current menu should be highlighted
              var menuCSS = "inline-block";

              if (
                (section === item.identifier && !subsection && !item.action) ||
                (section === item.identifier && item.action === subsection)
              ) {
                menuCSS += " top-menu-highlighted";
              }

              const handleMenuClick = () => {
                // Check if user needs specialist access for creating CHElements
                if (item.action === AppSubSections.CREATE && authManager.isVisitor()) {
                  navigate(
                    SETTINGS.get_path({
                      section: AppSections.USERS,
                      subsection: AppSubSections.ROLE_REQUEST,
                    }),
                  );
                } else {
                  navigate(
                    SETTINGS.get_path({
                      section: item.identifier,
                      subsection: item.action,
                    }),
                  );
                }
              };

              return (
                <li
                  key={item.identifier + "_" + index}
                  className="inline-block mx-4"
                >
                  <a
                    onClick={handleMenuClick}
                    className={menuCSS}
                  >
                    <div className={"top-menu-item " + menuCSS}>
                      {item.label}
                    </div>
                  </a>
                </li>
              );
            })}
        </ul>
        {authManager.getUserID() && (
          <div className="relative ms-3">
            <a
              className="flex items-center whitespace-nowrap text-black/60 transition duration-200 hover:text-black/80 hover:ease-in-out focus:text-black/80 active:text-black/80 motion-reduce:transition-none"
              onClick={toggleSubmenu}
              role="button"
            >
              {AppIcons.USER}
              <span style={{ marginLeft: "4px" }}>
                {authManager.getUserName()}
              </span>
              <span className="ps-1 [&>svg]:w-5">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fillRule="evenodd"
                    d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z"
                    clipRule="evenodd"
                  />
                </svg>
              </span>
            </a>
            {submenuOpen && (
              <ul
                className="absolute right-0 left-auto z-[1000] float-left m-0 min-w-[10rem] list-none overflow-hidden rounded-lg border-none bg-white bg-clip-padding text-left text-base shadow-lg data-[twe-dropdown-show]:block"
                ref={menuRef}
              >
                {/*<li key="1">
                <a className={submenuLinkCSS} href="#">
                  <FaUserEdit className="inline-block mr-2" />
                  My profile
                </a>
              </li>*/}
                <li key="2">
                  <a
                    className={submenuLinkCSS}
                    href="#"
                    onClick={() => {
                      // navigate(
                      //   SETTINGS.get_path({
                      //     section: AppSections.MY_LISTS,
                      //   })
                      // );
                      let user_id = authManager.getUserID()!;
                      navigate(
                        SETTINGS.get_path({
                          section: AppSections.USERS,
                          id: user_id,
                          subsection: AppSubSections.VIEW,
                        }),
                      );
                      setSubmenuOpen(false);
                    }}
                  >
                    <FaUser className="inline-block mr-2" />
                    User Profile
                  </a>

                  <a
                    className={submenuLinkCSS}
                    href="#"
                    onClick={() => {
                      navigate(
                        SETTINGS.get_path({
                          section: AppSections.MY_LISTS,
                        }),
                      );
                      setSubmenuOpen(false);
                    }}
                  >
                    <FaList className="inline-block mr-2" />
                    My lists
                  </a>
                </li>
                <li key="3">
                  <a
                    className={submenuLinkCSS}
                    onClick={() => {
                      signOut();
                      setSubmenuOpen(false);
                    }}
                  >
                    <FaSignOutAlt className="inline-block mr-2" />
                    Logout
                  </a>
                </li>
              </ul>
            )}
          </div>
        )}
        {!authManager.getUserID() && (
          <div className="relative ms-3">
            <a
              className="flex items-center whitespace-nowrap text-black/60 transition duration-200 hover:text-black/80 hover:ease-in-out focus:text-black/80 active:text-black/80 motion-reduce:transition-none"
              onClick={() => authManager.launchSSOAuthenticationChallenge()}
              role="button"
            >
              {AppIcons.USER}
              <span style={{ marginLeft: "6px" }}>Login / Register</span>
            </a>
          </div>
        )}
      </div>
    </nav>
  );
}

export default TopMenu;
